var _circle, _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgNavAddons = function SvgNavAddons(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 56,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.1,
    cx: 28,
    cy: 28,
    r: 28,
    fill: "#8FB4EC"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21 25a1 1 0 0 1 1 1 6.97 6.97 0 0 1 4.33 1.5h2.17c1.333 0 2.53.58 3.354 1.5H35a5 5 0 0 1 4.516 2.851C37.151 34.972 33.322 37 29 37c-2.79 0-5.15-.603-7.06-1.658A.998.998 0 0 1 21 36h-3a1 1 0 0 1-1-1v-9a1 1 0 0 1 1-1h3Zm1.001 3L22 33.022l.045.032C23.84 34.314 26.178 35 29 35c3.004 0 5.799-1.156 7.835-3.13l.133-.133-.12-.1a2.994 2.994 0 0 0-1.643-.63L35 31h-2.111c.072.322.111.656.111 1v1h-9v-2l6.79-.001-.034-.078a2.5 2.5 0 0 0-2.092-1.416L28.5 29.5h-2.93a4.984 4.984 0 0 0-3.568-1.5h-.001ZM20 27h-1v7h1v-7Zm14-6a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Zm-7-5a3 3 0 1 1 0 6 3 3 0 0 1 0-6Zm0 2a1 1 0 1 0 0 2 1 1 0 0 0 0-2Z",
    fill: "#247BFC"
  })));
};

export default SvgNavAddons;